module.exports = __webpack_public_path__ + "img/19.bf8bc01f.jpg";